<template>
    <div>
        <div class="TriggersTabsContainer">
            <div class="btn-position-wrap">
                <md-tabs class="md-tabs-wrapper container" md-sync-route md-alignment="left">
                    <span v-if="showTriggerTabs">
                        <md-tab md-label="Settings" to="/tour/trigger/settings"/>
                        <md-tab md-label="Notes" to="/tour/trigger/notes"/>
                    </span>
                    <span v-else>
                        <md-tab md-label="Triggers" to="/tour/topic/triggers"/>
                        <md-tab md-label="Notes" to="/tour/topic/notes"/>
                    </span>
                </md-tabs>
            </div>
            <hr/>
            <div>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('editor', ['showTriggerTabs'])
  }
};
</script>
<style lang="scss">
.TriggersTabsContainer .container {
    padding: 0px !important;
}

.TriggersTabsContainer .md-tabs .md-button {
    width: 172px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TopicTriggerNoteTabs.vue